import type { NavigateFunction } from 'react-router';
import { ROUTES } from '@/shared/config/routes';

export const OPPORTUNITIES_ROOM_AGENT_ID = 'opportunities-room';

export const openOpportunitiesRoom = (navigate: NavigateFunction): void => {
  void navigate(ROUTES.TOOLS_OPPORTUNITIES);
};
